var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedParticipantsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-participant-5616911 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.439 6.85175C10.439 8.79129 8.86662 10.3637 6.92708 10.3637C4.98751 10.3637 3.41518 8.79129 3.41518 6.85175C3.41518 4.91218 4.98751 3.33984 6.92708 3.33984C8.86662 3.33984 10.439 4.91218 10.439 6.85175ZM14.3899 9.48568C16.087 9.48568 17.4628 8.10989 17.4628 6.41276C17.4628 4.71563 16.087 3.33984 14.3899 3.33984C12.6928 3.33984 11.317 4.71563 11.317 6.41276C11.317 8.10989 12.6928 9.48568 14.3899 9.48568ZM19.2188 12.9976C19.2188 14.4523 17.0568 15.6315 14.3899 15.6315C14.0541 15.6315 13.7262 15.6128 13.4097 15.5773C13.7574 15.192 13.9509 14.7646 13.9509 14.3145C13.9509 13.0783 12.4908 12.0125 10.3858 11.5249C11.2536 10.8242 12.7231 10.3637 14.3899 10.3637C17.0568 10.3637 19.2188 11.5429 19.2188 12.9976ZM6.92708 17.3875C10.3213 17.3875 13.0729 16.0117 13.0729 14.3145C13.0729 12.6174 10.3213 11.2416 6.92708 11.2416C3.53284 11.2416 0.78125 12.6174 0.78125 14.3145C0.78125 16.0117 3.53284 17.3875 6.92708 17.3875Z",
    fill: "#9999CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedParticipantsIcon);
export default __webpack_public_path__ + "static/media/unSelectedParticipantsIcon.667f8b39d65601b690f02e1215d76e36.svg";
export { ForwardRef as ReactComponent };